import Grid from "@mui/material/Grid2";
import React, { useRef } from "react";
import EditVendorRatiosDialog from "../../components/dialog/EditRatiosDialog";
import StoreItem from "./StoreItem";
import StoreProfile from "./StoreProfile";
import VendorRatios from "./VendorRatios";

const VendorStore = ({
  storeProducts,
  storeData,
  state,
  setIsLoading,
  fetchVendorsDetails,
}) => {
  const openRatiosDialog = useRef();

  const handleEditCommmissionRatio = () => {
    openRatiosDialog.current.openDialog({ type: "commission" });
  };

  const handleSponsorShipRatio = () => {
    openRatiosDialog.current.openDialog({ type: "sponsorship" });
  };

  const handleUpdateRatio = () => {
    openRatiosDialog.current.closeDialog();
  };

  return (
    <>
      {/* Store profile */}
      <StoreProfile
        data={storeData}
        state={state}
        setIsLoading={setIsLoading}
        fetchVendorsDetails={fetchVendorsDetails}
      />

      {/* Ratios  */}
      {/* <Grid container my={3} spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <VendorRatios
            title={"Commission"}
            subtitle={"Commission Ratio"}
            ratio={"05"}
            handleEditRatio={handleEditCommmissionRatio}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <VendorRatios
            title={"Sponsorship"}
            subtitle={"Sponsorship Commission Ratio"}
            ratio={"05"}
            handleEditRatio={handleSponsorShipRatio}
          />
        </Grid>
      </Grid> */}

      {/* Store Item */}
      <StoreItem data={storeProducts} />

      {/* Edit Ratios SuspendDialog */}
      <EditVendorRatiosDialog
        ref={openRatiosDialog}
        handleUpdate={handleUpdateRatio}
      />
    </>
  );
};

export default VendorStore;
